interface Props {
  alt?: string;
  className?: string;
  name: string;
}

const Illustration = ({ alt, className, name }: Props) => (
  <img
    alt={alt || name}
    className={className}
    src={`http://cdn.realpage.com/images/illustrations/${name}.svg`}
  />
);

export default Illustration;
